'use strict';

import alertingService from './AlertingService';

angular.module('sfx.alerting', ['sfx.data', 'sfx.ui']).service('alertingService', alertingService);
